// DataConnectionCell — the Form meta & SQL table's live/not-live toggle.
//
// `checked` comes from server data and NOTHING else, so the Switch cannot
// desync: it simply doesn't move until the list refetches. onChange raises the
// intent to the page, which confirms and mutates — this cell never calls the
// API (the UnitDetailsDrawer idiom).
//
// Disabled without a table name, because the connect call needs one: turning
// this on is what saves the name typed into DbNameCell.

import { useTranslation } from 'react-i18next';
import { Switch } from '@/components/common';
import type { DataSetupForm } from '@/api/endpoints/dataSetupApi';

interface DataConnectionCellProps {
  form: DataSetupForm;
  /** Draft or persisted table name — empty means there is nothing to connect. */
  dbName: string;
  onToggle: (form: DataSetupForm, next: boolean) => void;
}

const DataConnectionCell = ({ form, dbName, onToggle }: DataConnectionCellProps) => {
  const { t } = useTranslation();
  return (
    <Switch
      checked={form.dbConnection}
      disabled={!dbName.trim()}
      aria-label={t(
        form.dbConnection ? 'data_setup_meta_connected' : 'data_setup_meta_not_connected',
      )}
      onChange={() => onToggle(form, !form.dbConnection)}
    />
  );
};

export default DataConnectionCell;
